/**
 * 创作者中心- 删除会话
 * @returns
 */
import { useAppDispatch } from "@/store/hooks";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Select,
  RadioGroup,
  Radio,
  Stack,
} from "@chakra-ui/react";
import down from "@/assets/down.svg";
import { ReactSVG } from "react-svg";
import { useState } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const IsMarkingModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const [isMarking, setIsMarking] = useState(true);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="420px" bg="#fff">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <Box mt="10px" fontSize={"14px"} color="#27314D">
            <Flex mb="14px" alignItems="center" justifyContent={"space-between"}>
              <Box mr="10px" fontSize="14px" color={"#27314D"}>
                是否自动打标
              </Box>
              <RadioGroup
                value={isMarking.toString()}
                onChange={(value) => {
                  setIsMarking(value==="true")
                }}
              >
                <Stack direction="row">
                  <Radio colorScheme="blue" value="true">
                    <Box color={"#27314D"} fontSize="14px">
                      是
                    </Box>
                  </Radio>
                  <Radio colorScheme="blue" value="false">
                    <Box color={"#27314D"} fontSize="14px">
                      否
                    </Box>
                  </Radio>
                </Stack>
              </RadioGroup>
            </Flex>
            <Flex mb="10px" alignItems="center">
              <Box mr="10px" fontSize="14px" color={"#27314D"}>
                风格
              </Box>
              <Select
                icon={<ReactSVG src={down} />}
                variant="Unstyled"
                flex={1}
                h="40px"
                border={"1px solid #DCE0EB"}
                borderRadius={0}
                fontSize="14px"
                color={"#8E94A9"}
              >
                <option value="建筑设计">建筑设计</option>
                <option value="城市规划">城市规划</option>
                <option value="室内设计">室内设计</option>
                <option value="景观设计">景观设计</option>
                <option value="其他">其他</option>
              </Select>
            </Flex>
          </Box>
          <Flex mt="40px" justifyContent={"flex-end"}>
            <Button
              w="76px"
              h="37px"
              mr="15px"
              bg="#CBD1DF"
              color={"#27314D"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#CBD1DF",
                color: "#8E94A9",
              }}
              onClick={() => onClose()}
            >
              取消
            </Button>
            <Button
              w="76px"
              h="37px"
              bg="#496AE1"
              color={"#FFFFFF"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#3F5BC1",
                color: "#E6E6E6",
              }}
            >
              完成
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default IsMarkingModal;
